import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query'

import type { PRAYER_TYPE } from '@/src/features/pray/models/prayerIntentionType.enum'

import { intentionApi } from '../api/intentionApi'
import type { TPrayersApi } from '../api/types/getIntentionPrayersApi.types'

export const INTENTION_PRAYER_QUERY_LIMIT = 20
export const getIntentionPrayersOptions = (intentionId: number, type: PRAYER_TYPE) =>
  infiniteQueryOptions({
    queryKey: ['intention_prayers', intentionId, type],
    queryFn: ({ signal, pageParam: queryParam }) =>
      intentionApi.getIntentionPrayers(
        { intentionId, type, offset: queryParam.offset, limit: queryParam.limit },
        { signal },
      ),
    getNextPageParam: (lastPage, _pages, { limit, offset }) =>
      lastPage.length === limit ? { offset: offset + limit, limit } : null,
    initialPageParam: { offset: 0, limit: INTENTION_PRAYER_QUERY_LIMIT },
    retry: 0,
    select: (data) => {
      let flatData: TPrayersApi[] = []

      for (const page of data.pages) {
        for (const item of page) {
          if (!flatData.some(({ id }) => id === item.id)) {
            flatData.push(item)
          }
        }
      }

      return flatData
    },
  })

export const useIntentionPrayersQuery = (intentionId: number, type: PRAYER_TYPE) =>
  useInfiniteQuery(getIntentionPrayersOptions(intentionId, type))
